import '../../style/';
import '../../button/style/';
import '../../flex/style/';
import './index.less';



/** WEBPACK FOOTER **
 ** ./components/pagination/style/index.web.tsx
 **/